import type { ReadFileResult } from './types.js';
import { readFileBufferFullAsync } from './read-file-buffer-full-async.js';

export async function readFileFullAsync(filePath: string, knownSize?: number): Promise<ReadFileResult> {
  const { buffer, size } = await readFileBufferFullAsync(filePath, knownSize);
  const raw = buffer.toString('utf8');
  const lines = raw.split(/\r?\n/);
  return { content: raw, totalLines: lines.length, size };
}
